module.exports = __webpack_public_path__ + "static/media/SM-ST-O2.7054e8d0.mp3";